/**
 * 4 nhóm thuộc tính của màn Cấu hình thống kê khách hàng.
 * `loai` là tham số gửi xuống API api/cau-hinh-thong-ke-khach-hang.
 */
const DANH_SACH_TAB = [
  {
    loai: "nghenghiep",
    tenTab: "Nghề nghiệp",
    moTa: "Quản lý nghề nghiệp của khách hàng",
    nhanCot: "Tên nghề nghiệp",
    tenThuocTinh: "nghề nghiệp",
  },
  {
    loai: "khuvuc",
    tenTab: "Khu vực",
    moTa: "Quản lý khu vực sinh sống của khách hàng",
    nhanCot: "Tên khu vực",
    tenThuocTinh: "khu vực",
  },
  {
    loai: "hinhthucvay",
    tenTab: "Hình thức vay",
    moTa: "Quản lý hình thức vay của khách",
    nhanCot: "Tên hình thức vay",
    tenThuocTinh: "hình thức vay",
  },
  {
    loai: "nguonkhach",
    tenTab: "Nguồn khách",
    moTa: "Quản lý nguồn khách hàng",
    nhanCot: "Tên nguồn khách",
    tenThuocTinh: "nguồn khách",
  },
];

export default DANH_SACH_TAB;
